/* PDP full-screen image viewer. Opens on the main gallery image or the zoom pill.
   Pinch-zoom works natively on touch; desktop gets click-to-zoom plus drag-to-pan. */
(function () {
  var ZOOM_LABEL = 'Tap to zoom';
  var gallery = document.querySelector('.elare-gallery');
  if (!gallery) return;
  var stage = gallery.querySelector('.elare-gallery__stage');
  var main = gallery.querySelector('.elare-gallery__main');
  if (!stage || !main || main.tagName !== 'IMG') return;

  function big(src) {
    if (!src) return src;
    return src.replace(/([?&]width=)\d+/, '$11800');
  }
  function sources() {
    var thumbs = gallery.querySelectorAll('.elare-gallery__thumbs img');
    var list = [];
    Array.prototype.forEach.call(thumbs, function (t, i) {
      list.push({ src: big(t.currentSrc || t.src), thumb: t, index: i });
    });
    if (!list.length) list.push({ src: big(main.currentSrc || main.src), thumb: null, index: 0 });
    return list;
  }
  function currentIndex(list) {
    var active = gallery.querySelector('.elare-gallery__thumbs img.is-active');
    for (var i = 0; i < list.length; i++) if (list[i].thumb === active) return i;
    var now = (main.currentSrc || main.src).replace(/([?&]width=)\d+/, '$11800');
    for (var j = 0; j < list.length; j++) if (list[j].src === now) return j;
    return 0;
  }

  var svgNS = 'http://www.w3.org/2000/svg';
  function icon(d, extra) {
    var s = document.createElementNS(svgNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    (extra || [d]).forEach(function (p) {
      var el = document.createElementNS(svgNS, p.charAt(0) === 'M' ? 'path' : 'circle');
      if (p.charAt(0) === 'M') el.setAttribute('d', p);
      s.appendChild(el);
    });
    return s;
  }
  function magnifier() {
    var s = document.createElementNS(svgNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    var c = document.createElementNS(svgNS, 'circle');
    c.setAttribute('cx', '11'); c.setAttribute('cy', '11'); c.setAttribute('r', '7');
    var l = document.createElementNS(svgNS, 'path'); l.setAttribute('d', 'M20 20l-4.3-4.3');
    var p = document.createElementNS(svgNS, 'path'); p.setAttribute('d', 'M11 8v6M8 11h6');
    s.appendChild(c); s.appendChild(l); s.appendChild(p);
    return s;
  }

  /* visible affordance, because a bare image does not read as tappable to this buyer */
  var hint = document.createElement('button');
  hint.type = 'button';
  hint.className = 'glb-hint';
  hint.setAttribute('aria-label', 'Open image full screen');
  hint.appendChild(magnifier());
  hint.appendChild(document.createTextNode(ZOOM_LABEL));
  stage.appendChild(hint);

  var box, imgEl, countEl, prevBtn, nextBtn, closeBtn, list = [], idx = 0, lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'glb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image viewer');
    box.setAttribute('data-open', 'false');
    box.setAttribute('data-zoom', '0');

    var canvas = document.createElement('div');
    canvas.className = 'glb__canvas';
    imgEl = document.createElement('img');
    imgEl.className = 'glb__img';
    imgEl.alt = main.alt || '';
    canvas.appendChild(imgEl);

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'glb__btn glb__close';
    closeBtn.setAttribute('aria-label', 'Close image viewer');
    closeBtn.appendChild(icon('M18 6L6 18M6 6l12 12'));

    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'glb__btn glb__prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.appendChild(icon('M15 18l-6-6 6-6'));

    nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'glb__btn glb__next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.appendChild(icon('M9 6l6 6-6 6'));

    countEl = document.createElement('p');
    countEl.className = 'glb__count';

    box.appendChild(canvas);
    box.appendChild(closeBtn);
    box.appendChild(prevBtn);
    box.appendChild(nextBtn);
    box.appendChild(countEl);
    document.body.appendChild(box);

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    canvas.addEventListener('click', function (e) { if (e.target === canvas) close(); });
    imgEl.addEventListener('click', function (e) { e.stopPropagation(); toggleZoom(e); });

    /* desktop drag to pan while zoomed */
    var down = false, sx = 0, sy = 0, sl = 0, st = 0;
    canvas.addEventListener('pointerdown', function (e) {
      if (box.getAttribute('data-zoom') !== '1' || e.pointerType === 'touch') return;
      down = true; sx = e.clientX; sy = e.clientY; sl = canvas.scrollLeft; st = canvas.scrollTop;
      box.setAttribute('data-panning', 'true');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      canvas.scrollLeft = sl - (e.clientX - sx);
      canvas.scrollTop = st - (e.clientY - sy);
    });
    window.addEventListener('pointerup', function () { down = false; box.removeAttribute('data-panning'); });

    document.addEventListener('keydown', function (e) {
      if (box.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { go(-1); }
      else if (e.key === 'ArrowRight') { go(1); }
      else if (e.key === 'Tab') {
        /* keep focus inside the viewer */
        var focusables = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden; });
        var i = focusables.indexOf(document.activeElement);
        e.preventDefault();
        focusables[(i + (e.shiftKey ? -1 : 1) + focusables.length) % focusables.length].focus();
      }
    });
    box.canvas = canvas;
  }

  function toggleZoom(e) {
    var zoomed = box.getAttribute('data-zoom') === '1';
    if (zoomed) {
      box.setAttribute('data-zoom', '0');
      return;
    }
    var r = imgEl.getBoundingClientRect();
    var fx = e ? (e.clientX - r.left) / r.width : 0.5;
    var fy = e ? (e.clientY - r.top) / r.height : 0.5;
    box.setAttribute('data-zoom', '1');
    var c = box.canvas;
    c.scrollLeft = (c.scrollWidth - c.clientWidth) * fx;
    c.scrollTop = (c.scrollHeight - c.clientHeight) * fy;
  }

  function paint() {
    imgEl.src = list[idx].src;
    box.setAttribute('data-zoom', '0');
    countEl.textContent = (idx + 1) + ' / ' + list.length;
    var one = list.length < 2;
    prevBtn.hidden = one;
    nextBtn.hidden = one;
    countEl.hidden = one;
  }
  function go(step) {
    idx = (idx + step + list.length) % list.length;
    paint();
  }
  function open() {
    if (!box) build();
    list = sources();
    idx = currentIndex(list);
    lastFocus = document.activeElement;
    paint();
    box.setAttribute('data-open', 'true');
    document.documentElement.classList.add('glb-locked');
    closeBtn.focus();
  }
  function close() {
    box.setAttribute('data-open', 'false');
    box.setAttribute('data-zoom', '0');
    document.documentElement.classList.remove('glb-locked');
    /* leave the page gallery on whatever she was last looking at */
    var t = list[idx] && list[idx].thumb;
    if (t) t.click();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  hint.addEventListener('click', function (e) { e.preventDefault(); open(); });
  main.addEventListener('click', open);
})();
